import React from 'react';

// TeamSection.jsx
const team = [
  {
    name: 'Ireneusz Marciniec',
    role: (
      <>
        Psychoterapeuta, specjalista psychoterapii <br /> dzieci i młodzieży
      </>
    ),
    phone: 'tel. 665 189 478',
    img: '/images/person1.jpeg',
  },
  {
    name: 'Nina Marciniec - Mika',
    role: 'Psycholog, logopeda',
    phone: 'tel. 789 133 528',
    img: '/images/person2.png',
  },
  {
    name: 'Bartłomiej Antos',
    role: 'DIETETYK KLINICZNY/PSYCHODIETETYK',
    phone: 'tel. 793 069 648',
    img: '/images/person3.jpg',
  },
];

const TeamSection = () => {
  return (
    <section className="bg-[#fdfcf9] py-20 px-4" id="onas">
      {/* Nagłówek */}
      <div className="text-center max-w-3xl mx-auto mb-16">
        <p className="text-[#d2a391] uppercase text-sm tracking-[0.2em] mb-2">
          O nas
        </p>
        <h2 className="text-3xl md:text-5xl font-alike text-darkGrey">
          PSYCHOTERAPIA Marciniec
        </h2>
        <p className="mt-6 text-grey leading-relaxed text-lg font-light">
          Oferujemy psychoterapię indywidualną w nurcie psychodynamicznym dla dorosłych,
          dzieci i młodzieży oraz wsparcie psychologiczne i terapię logopedyczną.
        </p>
      </div>

      {/* Zespół */}
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row justify-center items-start gap-10">
          {team.map((person, idx) => (
            <div key={idx} className="text-center w-full md:w-1/3">
              {/* zdjęcie */}
              <div className="aspect-[3/4] w-64 rounded-xl overflow-hidden shadow-md mx-auto">
                <img
                  src={person.img}
                  alt={person.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* stała wysokość na blok tekstu -> wszystko równo */}
              <div className="mt-4 flex flex-col items-center">
                <h3 className="text-lg font-semibold text-darkGrey min-h-[56px] flex items-center justify-center">
                  {person.name}
                </h3>

                <p className="text-base text-grey mt-1 mb-2 min-h-[28px] flex items-center justify-center">
                  {person.phone}
                </p>

                <p className="text-sm text-[#d2a391] uppercase tracking-wide mt-1 min-h-[44px] flex items-center justify-center">
                  {person.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
